import { render } from "./institutions.vue?vue&type=template&id=d812eae0&scoped=true"
import script from "./institutions.vue?vue&type=script&lang=js"
export * from "./institutions.vue?vue&type=script&lang=js"

import "./institutions.vue?vue&type=style&index=0&id=d812eae0&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d812eae0"]])

export default __exports__